<template>
  <p class="clearfix mb-0 text-center">
    <span class="d-block d-md-inline-block mb-2">
      Copyright  © {{ new Date().getFullYear() }}
      <b-link
        class="ml-25 text-white"
        href="https://deepblock.eu/"
        target="_blank"
      >Deep Block</b-link>
      <span class="d-none d-sm-inline-block">, Tous droits réservés</span>
    </span>

    <!-- <span class="float-md-right d-none d-md-block">Hand-crafted &amp; Made with
      <feather-icon
        icon="HeartIcon"
        size="21"
        class="text-danger stroke-current"
      />
    </span> -->
  </p>
</template>

<script>
import { BLink } from 'bootstrap-vue'

export default {
  components: {
    BLink,
  },
}
</script>
